<template>
  <span>
    <div v-for="(contact, index) in contacts" :key="index" class="contact">
      <span>{{ contact.firstName | capitalize }} {{ contact.lastName | capitalize }}</span>
    </div>
  </span>
</template>

<script>
export default {
  name: 'ContactsList',
  props: {
    contacts: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    phoneType(type) {
      switch (type) {
        case 'OFFICE':
        case 'HOME':
          return 'phone-square';
        case 'MOBILE':
          return 'mobile';
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '../styles/colors.scss';
@import '../styles/variables.scss';

span {
  text-transform: uppercase;
}
.contact {
  margin-bottom: 10px;
  padding: 15px;

  &:hover {
    padding: 15px;
    cursor: pointer;
    background-color: $mid-blue;
    border-radius: 8px;
  }
  .contact-email {
    font-weight: normal;
    color: $primary-blue;
  }
  .contact-phone {
    font-weight: normal;
    color: $mid-grey-2;
  }
}
</style>
